import * as CatalogActions from './actions';
import * as CatalogConstants from './constants';
import * as D from './deps';
import * as CatalogWorkers from './sagas';
import * as CatalogServices from './services';
import * as CatalogUtils from './utils';

const REFRESH_ANNOTATIONS_INTERVAL = 3000;

export default D.createDomainModule({
  name: 'catalog',
  actions: CatalogActions,
  utils: { ...CatalogUtils, getDetails: CatalogActions.getDetails },
  constants: {
    Explicitness: CatalogConstants.Explicitness,
    ReleaseType: CatalogConstants.ReleaseType,
  },
  services: CatalogServices,
  components: {},
  reducer: {},
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers([
      {
        actionType: CatalogConstants.OnDemandActions.ON_DEMAND_GET_ALBUM,
        concur: 'takeEvery',
        handler: CatalogWorkers.onGetAlbum,
      },
      {
        actionType: CatalogConstants.OnDemandActions.ON_DEMAND_GET_TRACK,
        concur: 'takeEvery',
        handler: CatalogWorkers.onGetTrack,
      },
      {
        actionType: D.Constants.Catalog.CatalogActions.CATALOG_GET_FULLLYRICS,
        concur: 'takeEvery',
        handler: CatalogWorkers.getFullLyrics,
      },
      {
        actionType: CatalogConstants.OnDemandActions.ON_DEMAND_GET_ARTIST_TOP_SONGS,
        concur: 'takeEvery',
        handler: CatalogWorkers.onGetArtistTopSongs,
      },
      {
        actionType: CatalogConstants.OnDemandActions.ON_DEMAND_GET_ARTIST_ALL_SONGS,
        concur: 'takeEvery',
        handler: CatalogWorkers.onGetArtistAllSongs,
      },
      {
        actionType: D.AnnotationActions.ENSURE_FULL_DATA,
        concur: 'takeEvery',
        handler: CatalogWorkers.ensureFullDataWorker,
      },
      {
        actionType: D.AnnotationActions.ANNOTATE_IDS,
        concur: 'takeEvery',
        handler: CatalogWorkers.annotateWorker,
      },
      {
        actionType: D.Constants.Catalog.CatalogActions.CATALOG_REFRESH_ANNOTATIONS,
        concur: 'takeOnlyDebounce',
        handler: CatalogWorkers.refreshAnnotationsWorker,
        wait: REFRESH_ANNOTATIONS_INTERVAL,
      },
      {
        actionType: D.Constants.Catalog.CatalogActions.CATALOG_GET_DETAILS,
        concur: 'takeEvery',
        handler: CatalogWorkers.getDetailsWorker,
      },
      {
        actionType: D.Constants.Catalog.CatalogActions.CATALOG_ANNOTATE_OBJECTS_SIMPLE,
        concur: 'takeEvery',
        handler: CatalogWorkers.annotateObjectsSimple,
      },
      {
        actionType: D.Constants.Catalog.CatalogActions.CATALOG_GET_ARTIST_DISCOGRAPHY,
        concur: 'takeEvery',
        handler: CatalogWorkers.getArtistDiscography,
      },
      {
        actionType: D.Constants.Catalog.CatalogActions.CATALOG_GET_ALL_ARTIST_TRACKS,
        concur: 'takeEvery',
        handler: CatalogWorkers.getAllArtistTracks,
      },
      {
        actionType: D.Constants.Catalog.CatalogActions.CATALOG_GET_ARTIST_EVENTS,
        concur: 'takeEvery',
        handler: CatalogWorkers.getArtistEvents,
      },
    ]);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
